export default __webpack_public_path__ + "static/media/1 - Адаптивная и тонизирующая гимнастика.299dad50.jpg";